import React from "react";
import { Grid, TextField } from "@mui/material";
import { formatDateAsLocaleString } from "utils/formatters/DateFormatters";
import type { UserDto } from "client/api/UsersApi";
import { DetailsPageLayout } from "components/DetailsPageLayout/DetailsPageLayout";
import { useEntity } from "components/EntityProvider/EntityProvider";

export function UserAuditDetails() {
  const { entity: user } = useEntity<UserDto>();

  if (!user) return <></>;

  return (
    <DetailsPageLayout pageName={"Audit"}>
      <Grid container spacing={3}>
        <Grid size={12}>
          <TextField
            label="Database ID"
            fullWidth
            variant="standard"
            defaultValue={user.id}
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <TextField
            label="Created by"
            fullWidth
            variant="standard"
            defaultValue={user.createdByUser}
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <TextField
            label="Created"
            fullWidth
            variant="standard"
            defaultValue={formatDateAsLocaleString(user.createdDate)}
            helperText={formatDateAsLocaleString(user.createdDate, true)}
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <TextField
            label="Last modified by"
            fullWidth
            variant="standard"
            defaultValue={user.lastModifiedByUser}
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 6,
          }}
        >
          <TextField
            label="Last modified"
            fullWidth
            variant="standard"
            defaultValue={formatDateAsLocaleString(user.lastModifiedDate)}
            helperText={formatDateAsLocaleString(user.lastModifiedDate, true)}
            slotProps={{
              input: {
                readOnly: true,
              },
            }}
          />
        </Grid>
      </Grid>
    </DetailsPageLayout>
  );
}
